import React, { FC } from 'react'
import Combination, { CombinationProps } from '../../atoms/combination'
import { isBieyangApp, idDev } from '../../utils/utils'
const isLegoEditor = window.location.hash.startsWith('#/lego/edit')
interface CombinationListProps {
  config: {
    ids: string[]
    combinations: CombinationProps['combination'][]
  }
  clickTo: (
    componentType?: string,
    nativeLink?: string,
    normalLink?: string,
    componentId?: string
  ) => void
  id: string
  pid: string
}

const CombinationList: FC<CombinationListProps> = ({
  config,
  id,
  clickTo,
}) => {
  const { combinations = [] } = config
  return (isBieyangApp() || isLegoEditor || idDev) ? (
    <div className="by-combination-list">
      {combinations.map((combination) => (
        <Combination
          key={combination.wdId}
          combination={combination}
          pid={id}
          clickTo={clickTo}
        />
      ))}
    </div>
  ) : null
}

export default CombinationList